import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { DELETE_FAVOURITE_LOCATION } from 'app/constants';
import deleteLocation from './deleteLocation';

export default function* watchDeleteLocation() {
  yield fork(takeLatest, DELETE_FAVOURITE_LOCATION, deleteLocation);
}
